import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default class ManageReportsReducer {

    static ManageReportsListReducer(state = initialState.Reports, action) {
          switch (action.type) {
            case types.GET_MANAGEREPORTS_LIST: return {
                ...state, MangeReportslist: action.getResponse,
             };
             default : return state; 
          }   
      }

    static ManageReportsSubListReducer(state = initialState.Reports, action) {
        switch (action.type) {
          case types.GET_MANAGEREPORTS_SUB_LIST: return {
              ...state, MangeReportsSublist: action.getResponse,
           };
           default : return state; 
        }
    }

    static RunReportsReducer(state = initialState.Reports, action) {
        switch (action.type) {
            case types.RUN_REPORT_FILE_LINK: return {
                ...state, RunReport_status: action.getResponse,
            };
            default: return state;
        }
    }
}  